import { Button } from '@heidi/design-system/button';
import { FormattedMessage } from 'react-intl';

interface Props {
  onSkip: () => void;
  disabled: boolean;
}

export function EvidenceSBSSkipButton({ onSkip, disabled }: Props) {
  return (
    <Button
      variant="ghost"
      size="sm"
      className="text-text-tertiary"
      disabled={disabled}
      onClick={onSkip}
    >
      <FormattedMessage id="C3aERQTgcR" defaultMessage="Skip selection" />
    </Button>
  );
}
